import Service from "../restService";


class ChsDeviceService extends Service {

    headers = () => {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Grpc-Metadata-Authorization': 'Bearer ' + this.getAuth(),
        }
    }

    isEmpty(obj) {
        for (let x in obj) { return false; }
        return true;
    }

    queryItems = (url, data) => {
        let query = {};

        if (data.limit && (data.limit !== '')) { query.limit = data.limit; }
        if (data.offset && (data.offset !== '')) { query.offset = data.offset; }
        if (data.tenantId && (data.tenantId !== '')) { query.tenantId = data.tenantId; }
        if (data.search && (data.search !== '')) { query.search = data.search; }

        if (!this.isEmpty(query)) {
            return this.QUERY(url, query);
        }
        else {
            return this.GET(url)
                .then(response => {
                    return this.queryItems(url, { limit: response.totalCount });
                });
        }
    }

    getApplications = (data) => {
        const url = 'applications';
        
        return this.queryItems(url, data).then(response => {
            this.storage.setItem('chirpstack/applications', 'list', response.result);
            return {storageTag: 'chirpstack/applications', storageItem: 'list'};
        });
    }

    getDeviceProfiles = (data) => {
        const url = 'device-profiles';
        
        return this.queryItems(url, data).then(response => {
            this.storage.setItem('chirpstack/device-profiles', 'list', response.result);
            return {storageTag: 'chirpstack/device-profiles', storageItem: 'list'};
        });
    }

    getTenants = (data) => {
        const url = 'tenants';

        return this.queryItems(url, data).then(response => {
            this.storage.setItem('chirpstack/tenants', 'list', response.result);
            return { storageTag: 'chirpstack/tenants', storageItem: 'list' };
        });
    }

    // getDevices = (data) => {
    //     const url = 'devices';

    //     return this.GET(url)
    //         .then(response => {
    //             this.storage.setItem('chirpstack/devices', 'list', response);
    //             return {storageTag: 'chirpstack/devices', storageItem: 'list'};
    //         });
    // }

    addDevice = (data) => {
        let url = 'devices'
        let device = { device: data };
        let jsonDevice = JSON.stringify(device);
        return this.POST(url, jsonDevice).then(response => {
            this.storage.setItem('chirpstack/', 'device', data);
            return {storageTag: 'chirpstack/', storageItem: 'device'};
        })
    }


    setDeviceKeys = (data) => {
        let url = 'devices/' + data.devEui + '/keys';
        let deviceKeys = { deviceKeys: data };
        let jsonDeviceKeys = JSON.stringify(deviceKeys);
        return this.POST(url, jsonDeviceKeys).then( response => {
            this.storage.setItem('chirpstack/', 'deviceKeys', data);
            return {storageTag: 'chirpstack/', storageItem: 'deviceKeys'};
        })
    }


}

export default ChsDeviceService;
